import React from 'react'
import { ColorValue, ViewProps } from 'react-native'
import Svg, { Path } from 'react-native-svg'

import { Color } from '../../style'

export interface Props extends Omit<ViewProps, 'hitSlop'> {
  color?: ColorValue
}
const HelpPointer = (props: Props) => {
  const { color, ...otherProps } = props
  return (
    <Svg width={20} height={13} {...otherProps}>
      <Path d="M8.373 1.278a2 2 0 0 1 3.255 0L20 13H0L8.373 1.278Z" fill={color || Color.modifiedGrey} />
    </Svg>
  )
}

export default HelpPointer
